import { ArenaHeaderButtonDefaultBox } from "./arena-header-button.default.box";

export const ArenaHeaderButtonBox = ArenaHeaderButtonDefaultBox;
